import Boards from '@shared/components/Boards';
import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Help from '@shared/components/Help';
import Configuration from '@modules/configuration/components/Configuration';
import AuthenticationLayout from '@shared/auth/AuthenticationLayout';
import LoggedOut from '@shared/auth/LoggedOut';
import EnvironmentLabel from '@shared/components/EnvironmentLabel';

const ProtectedRoute = lazy(() => import('@shared/auth/ProtectedRoute'));
const ExtendedInformationConfiguration = lazy(
  () => import('@modules/configuration/components/ExtendedInformationConfiguration'),
);

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Boards />} />
        <Route path="/help" element={<Help />} />
        <Route path="/logged-out" element={<LoggedOut />} />
        <Route path="/configuration" element={<Configuration />} />
        <Route element={<AuthenticationLayout />}>
          <Route
            path="/auth/callback"
            element={<Navigate to="/configuration" replace />}
          />
          <Route element={<ProtectedRoute />}>
            <Route path="/configuration/extended-information">
              <Route index element={<ExtendedInformationConfiguration />} />
              <Route
                path="extended-messages/:extendedMessageId"
                element={<ExtendedInformationConfiguration />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
      <EnvironmentLabel />
    </>
  );
}

export default App;
